import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, formatError } from "../lib/api";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pw1, setPw1] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [ok, setOk] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw1 !== pw2) { setError("As senhas não coincidem"); return; }
    if (pw1.length < 8) { setError("A senha deve ter pelo menos 8 caracteres"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw1 });
      setOk(true);
      setTimeout(() => nav("/login"), 2500);
    } catch (e) { setError(formatError(e)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center p-6" style={{ background: "var(--bg)" }}>
      <div className="w-full max-w-md" data-testid="reset-password-page">
        <div className="flex items-center gap-3 mb-8">
          <img src="/dbs-logo.jpeg" alt="DBS FIELD" className="w-10 h-10 object-cover" style={{ borderRadius: 2 }} />
          <div className="label-caps" style={{ letterSpacing: "0.2em" }}>DBS FIELD</div>
        </div>

        <div className="card p-6">
          <h2 className="text-2xl font-bold mb-6" style={{ fontFamily: "Chivo" }}>Nova senha</h2>

          {!token && (
            <div className="p-3 text-sm border mb-4" style={{ background: "rgba(239,68,68,0.08)", borderColor: "rgba(239,68,68,0.3)", color: "#FCA5A5" }}>
              Token ausente na URL. Solicite um novo link.
            </div>
          )}

          {ok ? (
            <div className="p-4 text-sm border text-center" style={{ background: "rgba(34,197,94,0.08)", borderColor: "rgba(34,197,94,0.3)", color: "#86EFAC" }}>
              Senha redefinida com sucesso! Redirecionando para o login...
            </div>
          ) : (
            <form onSubmit={submit}>
              {error && <div className="mb-4 px-3 py-2 text-sm border" style={{ background: "rgba(239,68,68,0.08)", borderColor: "rgba(239,68,68,0.3)", color: "#FCA5A5" }}>{error}</div>}
              <label className="label-caps block mb-1.5">Nova senha</label>
              <input className="input mb-4" type="password" value={pw1} onChange={(e) => setPw1(e.target.value)} required data-testid="reset-pw1" />
              <label className="label-caps block mb-1.5">Confirmar nova senha</label>
              <input className="input mb-6" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} required data-testid="reset-pw2" />
              <button className="btn btn-primary w-full" type="submit" disabled={loading || !token} data-testid="reset-submit">
                {loading ? "Salvando..." : "Redefinir senha"}
              </button>
            </form>
          )}

          <div className="mt-6 pt-4 border-t text-center" style={{ borderColor: "var(--border)" }}>
            <Link to="/login" className="text-xs" style={{ color: "var(--primary)" }}>← Voltar para login</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
